<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import ContactDetails from 'dashboard/components-next/Contacts/Pages/ContactDetails.vue';

const props = defineProps({
  contactId: { type: [String, Number], required: true },
  accountId: { type: [String, Number], required: true },
});

const { t } = useI18n();
const store = useStore();
const getContactById = useMapGetter('contacts/getContactById');
const uiFlags = useMapGetter('contacts/getUIFlags');

const contact = computed(() => getContactById.value(props.contactId));
const isLoading = computed(() => uiFlags.value.isFetchingItem);

onMounted(async () => {
  if (!contact.value) {
    await store.dispatch('contacts/show', { id: props.contactId });
  }
});
</script>

<template>
  <div class="flex flex-col h-full overflow-hidden">
    <div
      v-if="isLoading && !contact"
      class="flex items-center justify-center h-32 text-n-slate-11 text-sm"
    >
      <span class="i-lucide-loader-2 size-4 animate-spin mr-2" />
      {{ t('COPILOT.PANEL.LOADING') }}
    </div>
    <div v-else-if="contact" class="flex-1 min-h-0 overflow-y-auto p-4">
      <ContactDetails :selected-contact="contact" />
    </div>
  </div>
</template>
